import Vue from 'vue'
import { DARKMODE_LOCAL_STORAGE_KEY } from '@/constants'

export const snackbarState = Vue.observable({
  snackbar: {
    active: false,
    severity: 'info',
    message: 'snackbar message'
  }
})

export const portalState = Vue.observable({
  user: { permissions: [], businesses: [{ show_statistics: false, has_customers: false, is_oem: null }], role: '', business_id: null, enterprise_id: null },
  nightMode: localStorage.getItem(DARKMODE_LOCAL_STORAGE_KEY) === 'true',
  bearer: ''
})

export const mutations = {
  setUser (user: any) {
    portalState.user = user
  },
  setSnackbar (severity: 'success' | 'info' | 'error' | 'warning' = 'info', message = 'Saving changes...') {
    snackbarState.snackbar = {
      active: true,
      severity,
      message
    }
  },
  toggleNightMode () {
    localStorage.setItem(DARKMODE_LOCAL_STORAGE_KEY, `${!portalState.nightMode}`)
    portalState.nightMode = !portalState.nightMode
  },
  setBearer (bearer: string) {
    portalState.bearer = bearer
  }
}
